import { cloneDeep } from 'lodash'

export default {
  namespaced: true,

  state: {
    savedFilters: {
      allWorks: {},
      review: {},
      decline: {},

      efficiency: {},
      opposition: {},
      employeeDirectory: {},
      publicationsParent: {},
      protected: {}
    },

    savedEmployeeList: {
      decline: [],
      review: [],
      efficiency: [],
      publicationsParent: []
    }
  },

  getters: {
    savedFilter: state => pageName => {
      return cloneDeep(state.savedFilters[pageName])
    },

    savedEmployeeList: state => pageName => {
      return cloneDeep(state.savedEmployeeList[pageName])
    }
  },

  mutations: {
    setPageFilter(state, { pageName, filters }) {
      state.savedFilters[pageName] = cloneDeep(filters)
    },

    setEmployeeList(state, { pageName, employeeList }) {
      state.savedEmployeeList[pageName] = cloneDeep(employeeList)
    }
  }
}
